<form [formGroup]="form">
  <text-input
    formControlName="name"
    placeHolder="Name"
    [form]="form"
    [error]="formErrors.name"
  ></text-input>
  <text-area
    formControlName="dietary_requirements"
    placeHolder="Dietary Requirements"
    [form]="form"
    [error]="formErrors.dietary_requirements"
    [rows]="10"
  ></text-area>
  @if (requiresSubmit) {
    <div>
      <raised-button [styles]="{ width: '100%' }" (click)="handleSubmit()" color="primary">
        Submit
      </raised-button>
    </div>
  }
</form>
